import TextField from '@/components/TextField/TextField';
import theme from '@/theme';
import styled from '@emotion/styled';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import { InputAdornment } from '@mui/material';

const StyledTextField = styled(TextField)`
    outline: none;
    margin: 12px 0;
    border-radius: 8px;
    width: 100%;

    & .MuiOutlinedInput-root {
        & fieldset {
            border-color: ${theme.colors.black[300]} !important;
        }
    }

    input {
        font-size: 16px;
        caret-color: ${theme.colors.primary[900]};
    }
`;

const StyledInputStartAdornment = styled(InputAdornment)`
    color: ${theme.colors.secondary[900]};
    svg {
        width: 22px;
        height: 22px;
    }
`;

const StyledInputEndAdornment = styled(InputAdornment)`
    color: rgba(0, 0, 0, 0.3);
`;

interface Props {
    search: string;
    handleSearchChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
    handleClearSearch: (e: React.MouseEvent) => void;
}

export const SearchField = ({ search, handleSearchChange, handleClearSearch }: Props) => {
    return (
        <StyledTextField
            autoFocus
            placeholder="Search language"
            onChange={handleSearchChange}
            value={search}
            size="small"
            InputProps={{
                startAdornment: (
                    <StyledInputStartAdornment position="start">
                        <SearchIcon />
                    </StyledInputStartAdornment>
                ),
                endAdornment: search ? (
                    <StyledInputEndAdornment position="end">
                        <ClearIcon cursor="pointer" onClick={handleClearSearch} />
                    </StyledInputEndAdornment>
                ) : null,
            }}
        />
    );
};
